module.exports = __webpack_public_path__ + "static/img/acs.88f6357d.png";